// src/styles/invoice.styles.ts
import styled from 'styled-components';

export const Container = styled.div`
  padding: 5rem;
  margin: 0 auto;
  width: 80%;
`;

export const DocumentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DocumentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
`;

export const DocumentLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  input[type='checkbox'] {
    cursor: pointer;
  }
`;

export const DocumentName = styled.span`
  font-size: 14px;
`;

export const NoDocuments = styled.span`
  color: #666;
  font-style: italic;
  font-size: 14px;
`;
